export function parseAndValidatePrice(value: number | string): number | undefined {
  const trimmed = typeof value === "string" ? value.trim() : String(value);

  if (trimmed === "") {
    return undefined;
  }

  const normalized = trimmed.replace(",", ".");

  if (!/^\d+(\.\d+)?$/.test(normalized)) {
    return undefined;
  }

  const parsed = parseFloat(normalized);

  if (isNaN(parsed)) {
    return undefined;
  }

  return parsed;
}

export function normalizePriceRange(minValue: number | undefined, maxValue: number | undefined): [number | undefined, number | undefined] {
  if (minValue !== undefined && maxValue !== undefined && minValue > maxValue) {
    return [maxValue, minValue];
  }
  return [minValue, maxValue];
}
